
import { HttpClient, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IMenuCertificacionesDTO } from '../dto/menu-certificaciones.dto';
import { ICertificadoTipoGeneracionDTO } from '../dto/certificado-tipo-generacion.dto';

@Injectable({
  providedIn: 'root'
})
export class CertificacionesService {

  private urlEndPoint = environment.urlEndPoint.concat('/autenticado/certificaciones');

  public cerTipoGeneracion: ICertificadoTipoGeneracionDTO[] = [];

  constructor(private httpClient: HttpClient) { }

  public getMenuCertificacionesPorUsuario(): Observable<IMenuCertificacionesDTO[]>{
    return this.httpClient.get<IMenuCertificacionesDTO[]>(`${this.urlEndPoint}/obtener-menu-certificaciones`);
  }

  public getFoto(): Observable<any>{
    return this.httpClient.get(`${this.urlEndPoint}/obtener-foto`, {responseType: 'blob'});
  }

/**
    public generarCertificado(certificadoInfo: ICertificadoInfoDTO): Observable<any>{
    return this.httpClient.post(`${this.urlEndPoint}/generar-certificado`, certificadoInfo, { observe: 'response', responseType: 'blob' });
  }

  public generarCertificado(certificadoInfo: ICertificadoInfoDTO, estCodigo: string, certgCodigo: string ): Observable<any>{
    let parametros = new HttpParams();
    parametros = parametros.set('estCodigo', estCodigo);
    parametros = parametros.set('certgCodigo', certgCodigo);
    return this.httpClient.post(`${this.urlEndPoint}/generar-certificado`, certificadoInfo, { params: parametros, observe: 'response', responseType: 'blob' });
  }
   **/
  public generarFichaAcademicaGraduado(liqCodigo: string): Observable<any> { 
    return this.httpClient.post(`${this.urlEndPoint}/generar-ficha-academica-graduado`, null,{params: { liqCodigo },observe: 'response' , responseType: 'blob' });
  }

}
